import './product_qty.css';
import { MinusIcon } from "../../assets/icons/MinusIcon";
import { PlusIcon } from "../../assets/icons/PlusIcon";
import { useSingleProduct } from "../../context/SingleProductContext";

export const ProductQty = () => {
    //HOOKS
    const { qty, setQty } = useSingleProduct();

    //FUNCTIONS
    const add = () => {
        setQty(qty + 1);
    }

    const remove = () => {
        if (qty > 1) {
            setQty(qty - 1);
        }
    }

    return (
        <div className='product_qty'>
            <span className='less_button' onClick={remove}>
                <MinusIcon />
            </span>
            <div className='qty_input'>
                {qty}
            </div>
            <span className='plus_button' onClick={add}>
                <PlusIcon />
            </span>
        </div>
    );  
}